import { jsx as e } from "react/jsx-runtime";

import { useRef as o, useCallback as t, useLayoutEffect as r } from "react";

import n from "../hooks/useGlobals.js";

const s = ({children: s, onClose: d}) => {
    const {model: c} = n(), l = o(null), u = t((() => {
        "boolean" == typeof c.opened && l.current && (c.opened ? l.current.open || l.current.showModal() : l.current.open && l.current.close());
    }), [ c.opened ]);
    r((() => {
        u();
    }), [ u ]);
    const a = t((e => {
        l.current && l.current === e.target && c.toggle(!1);
    }), [ c.toggle ]);
    return r((() => (document.addEventListener("mousedown", a), document.addEventListener("touchstart", a), 
    () => {
        document.removeEventListener("mousedown", a), document.removeEventListener("touchstart", a);
    })), []), e("dialog", {
        onClose: d,
        ref: l,
        "aria-labelledby": c.ids.label ?? c.ids.input,
        children: s
    });
};

export { s as default };
//# sourceMappingURL=Dialog.js.map
